export const VERSION = process.env.REACT_APP_VERSION || new Date().toISOString().split('T')[0]; 